// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"167":"cbb1bd0e","945":"45e6efd8"}[chunkId] + ".css";
};